(($) => {

    // Regular carousel
    $('.slider_slick').slick({
        arrows: true,
        prevArrow: $('.text_and_slider .card_prev_button'),
        nextArrow: $('.text_and_slider .card_next_button'),
    });

    $initial_slide_count = $('.slider_slick').slick('getSlick').slideCount;

    $('.text_and_slider .page_info').text('1/' + $initial_slide_count);

    $('.slider_slick').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        let newi = i + '/' + slick.slideCount;
        $('.text_and_slider .page_info').text(newi);
    });

    //create a slick carousel for the timeline with a custom nav
    $('.timeline_carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $('.timeline .card_prev_button'),
        nextArrow: $('.timeline .card_next_button'),
        asNavFor: '.navigational_segments',
        adaptiveHeight: false,
    });

    $('.navigational_segments').slick({
        slidesToShow: 20,
        slidesToScroll: 1,
        asNavFor: '.timeline_carousel',
        arrows: false,
        focusOnSelect: true,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 14
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 10
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 8
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });


    // Numbers rise up in intro
    function countUp(start, end, duration, element){
        var stepTime = Math.abs(Math.floor(duration / (end - start)));
      
        function updateCounter(current) {
          if (current > end) return;
          $('.' + element).text(current);
          setTimeout(function() {
            updateCounter(current + 1);
          }, stepTime);
        }
    
        updateCounter(start);
    }
    
    countUp(0, 400, 1500, 'specs_title_number--1');
    countUp(0, 100, 1500, 'specs_title_number--2');
    countUp(0, 40, 1500, 'specs_title_number--3');
    countUp(0, 80, 1500, 'specs_title_number--4');
})(jQuery);